import React, { useMemo } from 'react';
import {
  FONTS,
  LIST_GAP_HORIZONTAL,
  SCREEN_PADDING_SMALL,
  TYPOGRAPHY,
} from '@/styles';
import { getTitleFromInput } from './utils';
import { InboundListItem } from './types';
import { StyleSheet, Text, View } from 'react-native';

interface Props {
  children?: React.ReactNode;
  inboundListItem: InboundListItem;
  showTranslation?: boolean;
}

export const InboundDetailListItemHeader: React.FC<Props> = ({
  children,
  inboundListItem,
  showTranslation,
}) => {
  const dynamicTitle = useMemo(() => {
    const inputWithResult = inboundListItem.metadata?.inputWithResult;
    if (inputWithResult) {
      return getTitleFromInput(inputWithResult, showTranslation);
    }
    return inboundListItem.title;
  }, [inboundListItem, showTranslation]);

  return (
    <View style={styles.listItemHeader}>
      <Text style={[TYPOGRAPHY.large, FONTS.primaryBold, styles.title]}>
        {dynamicTitle}
      </Text>
      {children}
    </View>
  );
};

const styles = StyleSheet.create({
  listItemHeader: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: LIST_GAP_HORIZONTAL,
    justifyContent: 'space-between',
    marginHorizontal: SCREEN_PADDING_SMALL,
  },
  title: {
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    minHeight: 32,
  },
});
